const GUIDED_RECEIVED_REQUEST_PROFILE = Object.freeze({
    name: 'received-request-guided-document-review',
    presentation: 'modal',
    navigation: 'single',
    processCompletionMode: 'manual',
    allowedProcessDecisions: Object.freeze(['continue']),
    renderer: 'document-compliance',
    context: Object.freeze({ legislations: true }),
    rendererOptions: Object.freeze({
        claimEditor: 'guided',
        layout: 'split-products-first-v1',
        initialization: Object.freeze({ showOverlay: true }),
        heading: Object.freeze({ showTitle: false }),
        relevance: Object.freeze({
            variant: 'completion-radio-v1',
            requiredForCompletion: true,
        }),
        sections: Object.freeze({
            documentPreview: Object.freeze({ visible: true, variant: 'standard-v1' }),
            documentInformation: Object.freeze({
                visible: true,
                variant: 'guided-v1',
                showUnknownScope: false,
            }),
            regulations: Object.freeze({
                visible: true,
                variant: 'guided-v1',
                showDescription: true,
                showTabSubstanceCount: true,
                showTabAttention: true,
                hideEmptyNegativeSubstances: true,
                hideSubstancesUntilDeclaration: true,
                allowRemoveRegulation: true,
                ensureScipRegulationForNumber: true,
                substanceDeclarationInference: Object.freeze({
                    mode: 'apply-when-empty',
                }),
                visibilityPolicies: Object.freeze({
                    scip: Object.freeze([
                        'show-scip-with-document-number-v1',
                        'hide-scip-for-reach-without-restricted-substances-v1',
                    ]),
                }),
                content: Object.freeze({
                    default: 'substance-v1',
                    byLegislation: Object.freeze({
                        scip: 'scip-v1',
                    }),
                }),
            }),
            scipInformation: Object.freeze({ visible: false, variant: 'standard-v1' }),
            substances: Object.freeze({ visible: false, variant: 'standard-v1' }),
            products: Object.freeze({
                visible: true,
                variant: 'guided-v1',
                allowAddProduct: false,
                allowAddAttribute: false,
                visibleWhen: Object.freeze({
                    fact: 'document.scope',
                    equals: 'product_specific',
                }),
            }),
        }),
    }),
    productLookup: Object.freeze({
        defaultMode: 'organization-products',
        allowedModes: Object.freeze([
            'organization-products',
            'supplier-products',
        ]),
    }),
    suggestions: Object.freeze([
        Object.freeze({
            policy: 'suggest-scope-from-extracted-products',
            behavior: 'preselect',
        }),
    ]),
})

const REVIEW_PROFILES = Object.freeze({
    'received-request-document-review': Object.freeze({
        name: 'received-request-document-review',
        presentation: 'modal',
        navigation: 'single',
        processCompletionMode: 'manual',
        allowedProcessDecisions: Object.freeze(['continue', 'reject']),
        renderer: 'document-compliance',
        rendererOptions: Object.freeze({
            claimEditor: 'guided',
            layout: 'split-v1',
            sections: Object.freeze({
                documentPreview: Object.freeze({ visible: true, variant: 'standard-v1' }),
                documentInformation: Object.freeze({ visible: true, variant: 'standard-v1' }),
                regulations: Object.freeze({ visible: true, variant: 'standard-v1' }),
                scipInformation: Object.freeze({ visible: true, variant: 'standard-v1' }),
                substances: Object.freeze({ visible: true, variant: 'standard-v1' }),
                products: Object.freeze({ visible: true, variant: 'standard-v1' }),
            }),
        }),
        productLookup: Object.freeze({
            defaultMode: 'organization-products',
            allowedModes: Object.freeze([
                'organization-products',
                'supplier-products',
            ]),
        }),
        suggestions: Object.freeze([
            Object.freeze({
                policy: 'suggest-scope-from-extracted-products',
                behavior: 'preselect',
            }),
        ]),
    }),
    'received-request-guided-document-review': GUIDED_RECEIVED_REQUEST_PROFILE,
    'received-request-guided-document-research-review': Object.freeze({
        ...GUIDED_RECEIVED_REQUEST_PROFILE,
        name: 'received-request-guided-document-research-review',
        navigation: 'adaptive',
        navigationOptions: Object.freeze({
            showItemSelector: false,
            showAdjacentNavigation: true,
            showProgress: true,
            progressMode: 'position',
            showSummary: false,
        }),
    }),
    'research-review-document-item': Object.freeze({
        name: 'research-review-document-item',
        presentation: 'modal',
        navigation: 'single',
        processCompletionMode: 'manual',
        allowedProcessDecisions: Object.freeze([]),
        renderer: 'document-compliance',
        rendererOptions: Object.freeze({
            claimEditor: 'structured',
            layout: 'split-v1',
            sections: Object.freeze({
                documentPreview: Object.freeze({ visible: true, variant: 'standard-v1' }),
                documentInformation: Object.freeze({ visible: true, variant: 'standard-v1' }),
                regulations: Object.freeze({ visible: true, variant: 'standard-v1' }),
                scipInformation: Object.freeze({ visible: true, variant: 'standard-v1' }),
                substances: Object.freeze({ visible: true, variant: 'standard-v1' }),
                products: Object.freeze({ visible: true, variant: 'standard-v1' }),
            }),
        }),
        processDecisions: false,
        productLookup: Object.freeze({
            defaultMode: 'organization-products',
            allowedModes: Object.freeze([
                'organization-products',
                'supplier-products',
            ]),
        }),
        suggestions: Object.freeze([]),
    }),
})

const resolveReviewProfile = name => REVIEW_PROFILES[name] || null

export {
    REVIEW_PROFILES,
    resolveReviewProfile,
}
